import { 
  Target, 
  TrendingUp, 
  Clock, 
  Leaf
} from 'lucide-react';

const benefits = [
  { icon: Target, title: 'Reduce errores', description: 'Identificación precisa evita aplicaciones incorrectas' },
  { icon: Leaf, title: 'Optimiza insumos', description: 'Usa solo lo necesario, cuando es necesario' },
  { icon: Clock, title: 'Ahorra tiempo', description: 'Decisiones inmediatas sin depender de terceros' },
  { icon: TrendingUp, title: 'Mejora rendimiento', description: 'Acciones oportunas protegen tu producción' }
];

const integrations = [
  'Mapa de lotes',
  'Historial de trabajos',
  'Planificación agrícola',
  'Red de prestadores',
  'Sistema de pagos'
];

export const AgroScanSection = () => {
  return (
    <section
      id="agroscan"
      className="py-16 md:py-24 bg-[#051914]"
      data-testid="agroscan-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-bold uppercase tracking-[0.2em] text-[#A9CB68] mb-4">
            Nueva Funcionalidad
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight text-[#FBF5EA] mb-6">
            AgroScan
          </h2>
          <p className="text-xl md:text-2xl text-[#A9CB68] font-medium mb-4">
            Identificación inteligente para decisiones en el campo
          </p>
          <p className="text-base md:text-lg text-[#FBF5EA]/70 max-w-3xl mx-auto">
            Una herramienta integrada dentro de Prestagro que permite identificar en tiempo real 
            malezas, insectos y problemas en cultivos, transformando esa información en decisiones concretas.
          </p>
        </div>

        {/* Main Image */}
        <div className="mb-16">
          <div className="relative rounded-3xl overflow-hidden">
            <img
              src="https://customer-assets.emergentagent.com/job_prestagro-agro/artifacts/4qnu53ab_imagen%20prestagro.jpg"
              alt="AgroScan - Diagnóstico inteligente de enfermedades en plantas"
              className="w-full h-auto object-cover scale-105"
            />
          </div>
        </div>

        {/* Benefits */}
        <div className="mb-16">
          <div className="bg-[#A9CB68] rounded-3xl p-8 md:p-10">
            <h3 className="text-2xl font-medium text-[#051914] mb-8 text-center">Beneficios</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex flex-col items-center text-center">
                  <div className="w-14 h-14 bg-[#051914] rounded-xl flex items-center justify-center mb-4">
                    <benefit.icon size={28} className="text-[#A9CB68]" />
                  </div>
                  <h4 className="font-medium text-[#051914] mb-1">{benefit.title}</h4>
                  <p className="text-sm text-[#051914]/70">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Integration */}
        <div className="text-center mb-16">
          <h3 className="text-2xl md:text-3xl font-medium text-[#FBF5EA] mb-8">
            Integrado con todo el ecosistema Prestagro
          </h3>
          <div className="flex flex-wrap justify-center gap-4">
            {integrations.map((item, index) => (
              <span 
                key={index}
                className="px-6 py-3 bg-[#013527] text-[#FBF5EA] rounded-full text-sm border border-[#A9CB68]/20"
              >
                {item}
              </span>
            ))}
          </div>
        </div>

        {/* Future */}
        <div className="bg-[#013527] rounded-3xl p-8 md:p-10 border border-[#A9CB68]/20">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
            <div>
              <h3 className="text-xl font-medium text-[#FBF5EA] mb-2">Evolución futura</h3>
              <p className="text-[#FBF5EA]/60 text-sm">
                Identificación por video • Integración con drones • Alertas por zona • IA predictiva
              </p>
            </div>
            <p className="text-[#A9CB68] font-medium text-lg md:text-right max-w-md">
              AgroScan no es solo una herramienta de identificación. Es un sistema que transforma información en acción.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
